import React from 'react';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { useAuth } from '@context/auth/base';
import { useHeaderStore } from '@store/header';
import { NAV_LINKS } from '@utils/constants';
import { webappUriPath } from '@utils/url';
import { useShouldShowReferralEarningsIndicator } from '../Notification';
import { LinkIndicator, NewNavLink } from '../styles';

export function CollectorSignedInOptions({ variant }: { variant: 'desktop' | 'mobile' }) {
  const { close } = useHeaderStore();
  const { authUser } = useAuth();

  const showReferralEarningsIndicator = useShouldShowReferralEarningsIndicator();

  if (!authUser) return null;

  const isArtist = !!authUser?.artist;

  return (
    <>
      <AccessibleLink pathnameUri={webappUriPath(authUser.webappUri)} onClick={close}>
        <NewNavLink>My Profile</NewNavLink>
      </AccessibleLink>
      {!isArtist && (
        <AccessibleLink pathnameUri="/dashboard/earnings" onClick={close}>
          <NewNavLink>
            My Earnings
            {showReferralEarningsIndicator && <LinkIndicator variant={variant} />}
          </NewNavLink>
        </AccessibleLink>
      )}

      <AccessibleLink pathnameUri={NAV_LINKS.ProfileEdit} onClick={close}>
        <NewNavLink>Settings</NewNavLink>
      </AccessibleLink>
    </>
  );
}
